import React from "react"
import PropTypes from 'prop-types'
import { Link } from "react-router-dom"
import { Row, Col, BreadcrumbItem } from "reactstrap"
import Utils from "../../pages/Utility"

const Breadcrumb = props => {
  return (
    <Row>
      <Col className="col-12 ">
        <div className="page-title-box d-flex align-items-start align-items-center justify-content-between">
          <h4 className="page-title mb-0 font-size-18" style={{ color: Utils.textColor }}>{props.breadcrumbItem}</h4>
          <div className="page-title-right" style={{ color: Utils.textColor }}>
            <ol className="breadcrumb m-0">
              <BreadcrumbItem>
                <Link to="#" style={{ color: Utils.textColor }}>{props.title}</Link>
              </BreadcrumbItem>
              <BreadcrumbItem active>
                <Link to="#" style={{ color: Utils.textColor }}>{props.breadcrumbItem}</Link>
              </BreadcrumbItem>
            </ol>
          </div>
        </div>
      </Col>
    </Row>
  )
}

Breadcrumb.propTypes = {
  breadcrumbItem: PropTypes.string,
  title: PropTypes.string
}

export default Breadcrumb
